//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";

const TABLA = "ubicaciones";

// Realtime para listado
export const subscribeUbicaciones = (callback) => {
  return subscribeTable(TABLA, (rows) => {
    const ubicaciones = rows.map((ub) => ({
      ...ub,
      label: `${ub.id} - ${ub.nombre}`,
    }));

    callback(ubicaciones);
  });
};

export const creaUbicacion = ({ id, ...data }) => createRow(TABLA, id, data);

export const updaUbicacion = (id, data) => updateRow(TABLA, id, data);

export const deleUbicacion = (id) => deleteRow(TABLA, id);
